import React, { Fragment, useState } from 'react';
import { createPortal } from 'react-dom';

import { getSubcategoriesUrl } from '../../utilities/urlHelper';

import ColorPicker from '../CategoryColorPicker';

import { CATEGORY_ORDER_BY_DEFAULT } from '../../utilities/CONSTANTS';
import { categoryToEditorState } from '../../tettra-editor/utilities/contentToEditorState';
import editorStateToRawContent from '../../tettra-editor/utilities/editorStateToRawContent';
import TettraEditor from '../../tettra-editor/components/TettraEditor';
import editorStateToHTML from '../../tettra-editor/utilities/editorStateToHTML';
import { randomHex } from '../../common/utils';

const categoryIcons = CATEGORY_ICONS;
const CATEGORY_BASE_PATH = '/img/category-icons/';
const DEFAULT_ICON = 'folder.svg';
const EDITOR_CONFIG = {
    enableSmallEditor: true,
    spellCheck: true,
    enableAutosave: false,
    enableTables: false,
    enableInsertControls: false,
    enableMentionSuggestions: true,
    enableInternalSuggestions: true,
    enableExternalSuggestions: false,
    enableFileUpload: false,
};

const CategoryOrder = (props) => (
    <div className="mb3">
        <label className="bold block col-12 mb1">
            What order should the items appear in?
        </label>
        <select className="'block col-6 field" name="order_type">
            { Object.keys(CATEGORY_ORDER_BY_DEFAULT).map((key) => {
                const name = key.toLowerCase().split('_').join(' ');
                return (
                    <option value={CATEGORY_ORDER_BY_DEFAULT[key]} key={key} title={name}>
                        {name}
                    </option>
                );
            })}
        </select>
    </div>
);

const CategoryIcons = (props) => (
    <div className="mb3">
        <label className="bold blocl col-12 mb1">
            Icon
        </label>
        <div className="clearfix">
            {categoryIcons.map((icon) => (
                <label className="img-radio" key={icon}>
                    <input type="radio" value={CATEGORY_BASE_PATH + icon} name="icon" defaultChecked={icon === DEFAULT_ICON} />
                    <img height="30" width="30" src={CATEGORY_BASE_PATH + icon} style={{ backgroundColor: `#${props.color}` }} />
                </label>
            ))}
        </div>
    </div>

);

const CreateSubcategoryModal = (props) => {
    const { categoryId, parentFolderId, parentName } = props;
    const [color, setColor] = useState(randomHex());
    const [editorState, setEditorState] = useState(categoryToEditorState(null));
    const html = editorStateToHTML(editorState);
    const contentStateJSON = JSON.stringify(editorStateToRawContent(editorState));

    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            return props.closeModal();
        }
    };

    return (
        <div className="react-modal open" onMouseDown={onClickModal}>
            <div className="modal-content p2">
                <h2>
                    {`Create new subcategory in "${parentName}"`}
                </h2>
                <form method="POST" action={getSubcategoriesUrl()}>
                    <input name="_token" type="hidden" defaultValue={window.csrfToken} />
                    <input name="category_id" type="hidden" defaultValue={categoryId} />
                    <input name="parent_folder_id" type="hidden" defaultValue={parentFolderId} />
                    <div className="form-group mb3">
                        <label htmlFor="name" className="bold block col-12 mb1">Name</label>
                        <input className="block col-12 mb2 field" placeholder="e.g. Announcements, Sales Playbook, etc." name="name" type="text" id="name" />
                    </div>
                    <div className="mb3">
                        <label htmlFor="description" className="bold block col-12 mb1">Description (optional)</label>
                        <div className="question-editor mb3">
                            <TettraEditor
                                config={EDITOR_CONFIG}
                                editorState={editorState}
                                updateModel={setEditorState}
                                setUploading={() => {}}
                            />
                        </div>
                        <input type="hidden" name="description" value={html} />
                        <input type="hidden" name="description_content_state" value={contentStateJSON} />
                    </div>
                    <div className="mb3">
                        <ColorPicker pickColor={setColor} color={color} />
                    </div>
                    <CategoryIcons color={color} />
                    <CategoryOrder />
                    <div className="right-align mt2">
                        <span className="btn-secondary mr1" aria-label="Close" role="button" onClick={props.closeModal}>Cancel</span>
                        <input className="btn btn-primary" type="submit" value="Create subcategory" />
                    </div>
                </form>
            </div>
        </div>
    );
};

const CreateSubcategoryWrapper = (props) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <Fragment>
            <span className="dropdown-option link" onClick={() => setShowModal(true)}>
                {!props.isSidebar && <img className="flex-none mr2" height="18" width="18" src="/img/icons/folder-icon.png" alt="" />}
                {props.isSidebar ? 'New subcategory' : 'Subcategory'}
            </span>
            {showModal && createPortal(<CreateSubcategoryModal closeModal={() => setShowModal(false)} {...props} />, document.body)}
        </Fragment>
    );
};

export default CreateSubcategoryWrapper;
